module.exports = {"object":"value","document":{"object":"document","nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"This example shows how you might implement a version history, where you can save a new version after applying some changes, and then rollback to a previous version at any time."}]}]}}


//////////////////
// WEBPACK FOOTER
// ./examples/versions/value.json
// module id = 768
// module chunks = 0